import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { currencyFormat } from 'utils/number';
import { SetStateAction } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

export interface IItem {
  id: string;
  name: string;
  quantity: number;
  remarks: string;
  total_price: number;
  unit_price: number;
  paid: boolean;
  picked: boolean;
}

interface ItemProps {
  selected: boolean;
  item: IItem;
  setSelect: (val: SetStateAction<IItem[]>) => void;
}

interface ItemWrapperProps {
  selected: boolean;
  paid: boolean;
  picked: boolean;
}

const ItemWrapper = styled.div<ItemWrapperProps>`
  padding: 20px;
  margin: 10px 0px;

  background: #ffffff;
  border: 1px solid #dbe1e6;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  background: ${({ selected }) => selected && '#e9eeff'};

  ${({ paid }) =>
    paid &&
    css`
      background: #fafafa;
      color: #8995a0;
    `}
`;

export const Item = ({ item, setSelect, selected }: ItemProps) => {
  const { t } = useTranslation();
  const paid = item.paid;
  const picked = item.picked;

  const handdleOnclick = () => {
    if (paid) return;
    setSelect((prev) => {
      const select = prev.includes(item)
        ? prev.filter((data) => data.id !== item.id)
        : [...prev, item];

      return select;
    });
  };

  return (
    <ItemWrapper onClick={() => handdleOnclick()} selected={selected} paid={paid} picked={picked}>
      <Grid container>
        <Grid xs={6} item style={{ textAlign: 'left' }}>
          <Typography>
            {item.name} x {item.quantity}
          </Typography>
        </Grid>
        <Grid xs={6} item style={{ textAlign: 'right' }}>
          <Typography>
            {(paid || picked) && <Chip label={paid ? t('paid') : picked && t('splitBillPicked')} />}{' '}
            {currencyFormat(item.total_price)}
          </Typography>
        </Grid>
      </Grid>
    </ItemWrapper>
  );
};
